// @flow
import * as React from "react"
import { type HOC } from "recompose"
import withLocation from "hoc/withLocation"
import { type User } from "data/user/types"
import OverlayWrapper from "./OverlayWrapper"
import HamburgerToggle from "./HamburgerToggle"
import Sidebar from "./Sidebar"

const Hamburger = ({ toggleOpen, close, isOpen, user }) => (
  <OverlayWrapper isOpen={isOpen} onClose={close}>
    <HamburgerToggle toggle={toggleOpen} />
    <Sidebar isOpen={isOpen} user={user} close={close} />
  </OverlayWrapper>
)

type Outter = {|
  user?: User,
  isOpen: boolean,
  open: Function,
  close: Function,
  toggleOpen: Function,
|}

const enhancer: HOC<*, Outter> = withLocation(props => props.close())

export default enhancer(Hamburger)



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/Hamburger/index.js